import type { HTMLAttributes } from 'react'

import type { Page } from '@subaio/utils'

import { useLink } from './useLink'

export type Props = Omit<HTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'> & {
	name: Page['name']
	params?: Page['params']
	query?: Page['query']
	fragment?: Page['fragment']

	replace?: boolean
	activeMatch?: 'parent' | 'path' | 'page' | 'exact'
	disabled?: boolean
	target?: string

	/** This is primarily used for doing cleanup when navigating, e.g. closing the currently opened modal. */
	onClick?: () => void
}

export const Link = ({
	name,
	params,
	query,
	fragment,
	replace,
	activeMatch,
	disabled,
	className,
	onClick: onLinkClick,
	...rest
}: Props) => {
	const { href, onClick, isActive } = useLink({ name, params, query, fragment }, { replace, activeMatch })

	if (isActive) {
		if (className) {
			className += ' active'
		} else {
			className = 'active'
		}
	}

	return (
		<a
			{...rest}
			className={className}
			href={disabled ? undefined : href}
			onClick={
				disabled
					? undefined
					: (event) => {
							if (onLinkClick) onLinkClick()
							onClick(event)
						}
			}
		/>
	)
}
